module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("收银台订单详情")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "promotion-ditail"
  }, [_c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("微信头像")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px"
    },
    attrs: {
      "src": _vm._f("defultHeadPic")(_vm.info.headimgurl)
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("微信昵称")]), _c('div', [_vm._v(_vm._s(_vm.info.nickname || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("使用门店")]), _c('div', [_vm._v(_vm._s(_vm.info.name))])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("优惠金额")]), _c('div', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.info.offer_money)) + " 元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("支付金额")]), _c('div', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.info.pay_money)) + " 元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("合计金额")]), _c('div', [_vm._v(_vm._s(_vm._f("filterMoney")(_vm.info.amount)) + " 元")])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("创建时间")]), _c('div', [_vm._v(_vm._s(_vm._f("momentFmt")(_vm.info.c_time)))])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("支付时间")]), _c('div', [_vm._v(_vm._s(_vm._f("momentFmt")(_vm.info.pay_time)))])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("订单号")]), _c('div', [_vm._v(_vm._s(_vm.info.order_no))])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("订单状态")]), _c('div', [_vm._v(_vm._s(_vm._f("filterOrderStatus")(_vm.info.status)))])]), _vm._v(" "), (_vm.info.refunds_time) ? _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("退款时间")]), _c('div', [_vm._v(_vm._s(_vm._f("momentFmt")(_vm.info.refunds_time)))])]) : _vm._e(), _vm._v(" "), (_vm.info.status == 4 || _vm.info.status == 5) ? _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("退款理由")]), _c('div', [_vm._v(_vm._s(_vm.info.refund_content || '--'))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("支付平台")]), _c('div', [_vm._v(_vm._s(_vm._f("filterOsType")(_vm.info.pay_type)) + "支付")])]), _vm._v(" "), _c('li', {
    staticClass: "fx fx-y-center"
  }, [_c('p', [_vm._v("支付终端")]), _c('div', [_vm._v(_vm._s(_vm.info.os_type))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-74339346","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/pay_manage/PayRecordInfo.vue
// module id = 867
// module chunks = 0